import { createTheme } from '@mui/material/styles';
import shadows from './shadows';
import typography from './typography';

const theme = createTheme({
  palette: {
    background: {
      dark: '#F4F6F8',
      default: '#ffffff',
      paper: '#ffffff'
    },
    primary: {
      main: '#3f51b5'
    },
    secondary: {
      main: '#f50057'
    },
    text: {
      primary: '#263238',
      secondary: '#546e7a'
    }
  },
  shadows,
  typography
});

export default theme;
